export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            如果你有优质视频资源推荐、站点合作建议或内容投稿需求，
            欢迎通过以下方式与我们取得联系，我们会在第一时间回复你的消息。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 px-6 py-4 rounded-xl bg-background-50 border border-background-200 cursor-default">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">投稿与合作邮箱</div>
                <div className="text-sm font-medium text-foreground-800">contact@69video.example.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3 px-6 py-4 rounded-xl bg-background-50 border border-background-200 cursor-default">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">官方微信号</div>
                <div className="text-sm font-medium text-foreground-800">69video_official</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}